import React from 'react';
import { DialogActions, Button } from '@mui/material';

interface DialogActionButtonsProps {
    selectedCount: number;
    onCancel: () => void;
    onAdd: () => void;
}

export const DialogActionButtons: React.FC<DialogActionButtonsProps> = ({
    selectedCount,
    onCancel,
    onAdd
}) => {
    return (
        <DialogActions>
            <Button onClick={onCancel}>
                Cancel
            </Button>
            <Button
                variant="contained"
                onClick={onAdd}
                disabled={selectedCount === 0}
            >
                Add Selected ({selectedCount})
            </Button>
        </DialogActions>
    );
};
